export default {
  data() {
    return {
      props: {
        name: 'BlogNewsSliderComponent',
        height: "200px",
        width: "200px",
        minHeight: "50px",
        zIndex: "auto",
        rotation: '0deg',
        opacity: 1,
        news: [
          {
            thumbnail: 'https://cdn.pixabay.com/photo/2014/05/02/21/50/home-office-336378_960_720.jpg',
            title: "My post title",
            content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
          },
          {
            thumbnail: 'https://cdn.pixabay.com/photo/2014/12/27/15/40/office-581131_960_720.jpg',
            title: "My post title",
            content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
          }
        ],
        optionNews: {
          totalNews: 4,
          featuredNews: false,
          showTitle: true,
          showDescription: true,
          redirectUrl: true
        },
        arrowOptions: true,
        arrowSize : '25px',
        arrowColor : '#d1d1d1',
        timerSlider: 3000,
        currentIndex: 0,
        autoPlaySlider: false,
        slider: null,
        titleTextContent: {
          family: 'arial, helvetica, sans-serif',
          size: '15px',
          sizeMobile: '15px',
          color: '#434343',
          align: 'center',
          weight: '700',
          style: 'initial',
          stroke : 'none'
        },
        subTextStyle: {
          family: 'arial, helvetica, sans-serif',
          size: '15px',
          sizeMobile: '15px',
          color: '#434343',
          align: 'center',
          weight: '400',
          style: 'initial',
          stroke : 'none'
        },
        infoContentPadding: {
          paddingTop: '5px',
          paddingLeft: '5px',
          paddingRight: '5px',
          paddingBottom: '5px',
        },
        infoContentHeight: '90px',
        infoContentColor: 'white',
        overflow: "hidden",
        border: "0 none #000000",
        boxShadow: "0 0 0 0 black initial",
        borderRadius: "0 0 0 0",
        animation: {
          in: {
            action: "time", //time/scroll/click/hover
            time: 0, // sec
            scroll: 0, // px
            effect: "none",
            speed: "slow",
            infinite: false
          },
          out: {
            action: "time", //time/scroll/click
            time: 0, // sec
            scroll: 0, // px
            effect: "none",
            delay: "1",
            speed: "1",
            infinite: false
          }
        },
      },
      internal_config: {
        zIndex: "auto",
        overflow: "hidden",
        news: [
          {
            thumbnail: 'https://cdn.pixabay.com/photo/2014/05/02/21/50/home-office-336378_960_720.jpg',
            title: "Meu primeiro texto",
            content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
          },
          {
            thumbnail: 'https://cdn.pixabay.com/photo/2014/12/27/15/40/office-581131_960_720.jpg',
            title: "Dripping teste",
            content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
          }
        ],
        optionNews: {
          totalNews: 4,
          featuredNews: false,
          showTitle: true,
          showDescription: true,
          redirectUrl: true
        },
        arrowOptions: true,
        arrowSize : '25px',
        arrowColor : '#d1d1d1',
        timerSlider: 3000,
        currentIndex: 0,
        autoPlaySlider: false,
        slider: null,
        titleTextContent: {
          family: 'arial, helvetica, sans-serif',
          size: '15px',
          sizeMobile: '15px',
          color: '#434343',
          align: 'center',
          weight: '700',
          style: 'initial',
          stroke : 'none'
        },
        subTextStyle: {
          family: 'arial, helvetica, sans-serif',
          size: '15px',
          sizeMobile: '15px',
          color: '#434343',
          align: 'center',
          weight: '400',
          style: 'initial',
          stroke : 'none'
        },
        infoContentHeight: '90px',
        infoContentColor: 'white',
        infoContentPadding: {
          paddingTop: '5px',
          paddingLeft: '5px',
          paddingRight: '5px',
          paddingBottom: '5px',
        },
        height: "200px",
        width: "200px",
        minHeight: "50px",
        left: "0px",
        top: "0px",
        showDesktop: true,
        showMobile: true,
        rotation: '0deg',
        opacity: 1,
        boxShadow: "0 0 0 0 black initial",
        borderRadius: "0 0 0 0",
      },
    };
  }
};
